import React, { Component } from 'react';
import CookieCategory from "./../../models/CookieCategory";

type CookieCategoryViewProps = {
    cookieCategory: CookieCategory
}

export default class CookieCategoryView extends Component<CookieCategoryViewProps, any> {

    render() {
        return (
            <div className="mw-lg-25 mx-0 my-1 px-2">
                <p className="font-weight-bolder text-small mb-0">{this.props.cookieCategory.title}</p>
                <span dangerouslySetInnerHTML={ { __html: this.props.cookieCategory.description}} className="d-block text-md-small text-smaller u-mb-gamma u-ms-1"></span>
            </div>
        );
    }
}